import fileDownload from 'js-file-download';
import moment from 'moment';

import { isTimeBefore } from 'utils/predicates/time/compare.util';

import {
  ACTUAL_SALES_DATA_FAILURE,
  ACTUAL_SALES_DATA_REQUEST,
  ACTUAL_SALES_DATA_SUCCESS,
  ALL_COMMISSION_REPORT_FAILURE,
  ALL_COMMISSION_REPORT_REQUEST,
  ALL_COMMISSION_REPORT_SUCCESS,
  APPOINTMENTS_REPORT_FAILURE,
  APPOINTMENTS_REPORT_REQUEST,
  APPOINTMENTS_REPORT_SUCCESS,
  BOOKING_LOG_CSV_FAILURE,
  BOOKING_LOG_CSV_REQUEST,
  BOOKING_LOG_CSV_SUCCESS,
  CHANGE_COMMISSION_RATE_FAILURE,
  CHANGE_COMMISSION_RATE_REQUEST,
  CHANGE_COMMISSION_RATE_SUCCESS,
  CLEAR_ALL_ERROR_MESSAGES,
  COMMISSION_REPORT_FAILURE,
  COMMISSION_REPORT_REQUEST,
  COMMISSION_REPORT_SUCCESS,
  CREATE_COMMISSION_RATE_FAILURE,
  CREATE_COMMISSION_RATE_REQUEST,
  CREATE_COMMISSION_RATE_SUCCESS,
  DAILY_REBOOKING_REPORT_FAILURE,
  DAILY_REBOOKING_REPORT_REQUEST,
  DAILY_REBOOKING_REPORT_SUCCESS,
  DELETED_BOOKING_LOG_CSV_FAILURE,
  DELETED_BOOKING_LOG_CSV_REQUEST,
  DELETED_BOOKING_LOG_CSV_SUCCESS,
  FORECAST_REVENUE_FAILURE,
  FORECAST_REVENUE_REQUEST,
  FORECAST_REVENUE_SUCCESS,
  GET_GLOBAL_DISCOUNT_FAILURE,
  GET_GLOBAL_DISCOUNT_REQUEST,
  GET_GLOBAL_DISCOUNT_SUCCESS,
  GET_MONTHLY_REVENUE_FAILURE,
  GET_MONTHLY_REVENUE_REQUEST,
  GET_MONTHLY_REVENUE_SUCCESS,
  GET_PRODUCT_SALES_BY_STYLIST_FAILURE,
  GET_PRODUCT_SALES_BY_STYLIST_REQUEST,
  GET_PRODUCT_SALES_BY_STYLIST_SUCCESS,
  GET_PRODUCT_SALES_FAILURE,
  GET_PRODUCT_SALES_REQUEST,
  GET_PRODUCT_SALES_SUCCESS,
  GET_STYLISTS_REQUESTS_FAILURE,
  GET_STYLISTS_REQUESTS_REQUEST,
  GET_STYLISTS_REQUESTS_SUCCESS,
  GET_UNIQUE_CLIENTS_FAILURE,
  GET_UNIQUE_CLIENTS_REQUEST,
  GET_UNIQUE_CLIENTS_SUCCESS,
  GET_UNIQUE_VISITS_FAILURE,
  GET_UNIQUE_VISITS_REQUEST,
  GET_UNIQUE_VISITS_SUCCESS,
  GET_VISIT_FREQUENCY_FAILURE,
  GET_VISIT_FREQUENCY_REQUEST,
  GET_VISIT_FREQUENCY_SUCCESS,
  NEW_CLIENTS_FAILURE,
  NEW_CLIENTS_REQUEST,
  NEW_CLIENTS_SUCCESS,
  REBOOKING_REPORT_FAILURE,
  REBOOKING_REPORT_REQUEST,
  REBOOKING_REPORT_SUCCESS,
  SALES_DISCOUNTS_REPORT_FAILURE,
  SALES_DISCOUNTS_REPORT_REQUEST,
  SALES_DISCOUNTS_REPORT_SUCCESS,
  SALES_REPORT_FAILURE,
  SALES_REPORT_REQUEST,
  SALES_REPORT_SUCCESS,
  SALON_HOURS_REPORT_FAILURE,
  SALON_HOURS_REPORT_REQUEST,
  SALON_HOURS_REPORT_SUCCESS,
  SET_CURRENT_TABLE,
  SET_DATE_PICKER_DATE,
  SET_GLOBAL_DISCOUNT_FAILURE,
  SET_GLOBAL_DISCOUNT_REQUEST,
  SET_GLOBAL_DISCOUNT_SUCCESS,
  SET_MONTHLY_DATE_PICKER_DATE,
  SET_SALON_VAT_RATE,
  SET_STYLIST_ID_ORDER,
  STYLIST_PERFORMED_CATEGORIES_FAILURE,
  STYLIST_PERFORMED_CATEGORIES_REQUEST,
  STYLIST_PERFORMED_CATEGORIES_SUCCESS,
  TRANSACTION_LOG_CSV_FAILURE,
  TRANSACTION_LOG_CSV_REQUEST,
  TRANSACTION_LOG_CSV_SUCCESS,
} from 'reports/actions';

// The idea of that reducer is that it handles all other logic
// that is not connected with actual fetching of reports, but it is part of the reports page
const reportsEtcReducer = (state, action) => {
  if (action && action.type) {
    switch (action.type) {
      case CREATE_COMMISSION_RATE_REQUEST: {
        const commissionReport = Object.assign({}, state.commissionReport);
        commissionReport.errorMessage = '';

        return { ...state, commissionReport };
      }
      case CREATE_COMMISSION_RATE_SUCCESS: {
        const commissionReport = Object.assign({}, state.commissionReport);
        commissionReport.errorMessage = '';
        commissionReport.lastRequestResponse.response.push(action.response);

        return { ...state, commissionReport };
      }
      case CREATE_COMMISSION_RATE_FAILURE: {
        const commissionReport = Object.assign({}, state.commissionReport);
        commissionReport.errorMessage = action.errorMessage;

        return { ...state, commissionReport };
      }
      case CHANGE_COMMISSION_RATE_REQUEST: {
        const commissionReport = Object.assign({}, state.commissionReport);
        commissionReport.errorMessage = '';

        return { ...state, commissionReport };
      }
      case CHANGE_COMMISSION_RATE_SUCCESS: {
        const commissionReport = Object.assign({}, state.commissionReport);
        commissionReport.errorMessage = '';
        for (
          let i = 0;
          commissionReport.lastRequestResponse && i < commissionReport.lastRequestResponse.response.length;
          i++
        ) {
          const commission = commissionReport.lastRequestResponse.response[i];
          if (commission.id === action.response.id) {
            commission.percentage = action.response.percentage;
            commission.error = '';
            break;
          }
        }
        return { ...state, commissionReport };
      }
      case CHANGE_COMMISSION_RATE_FAILURE: {
        const commissionReport = Object.assign({}, state.commissionReport);
        commissionReport.errorMessage = '';
        for (
          let i = 0;
          commissionReport.lastRequestResponse && i < commissionReport.lastRequestResponse.response.length;
          i++
        ) {
          const commission = commissionReport.lastRequestResponse.response[i];
          if (commission.id === action.params.data.id) {
            commission.error = 'Please enter a number > 0.';
            break;
          }
        }

        return { ...state, commissionReport };
      }
      case GET_GLOBAL_DISCOUNT_REQUEST: {
        const globalDiscount = Object.assign({}, state.globalDiscount);
        globalDiscount.errorMessage = '';
        globalDiscount.isFetching = true;

        return { ...state, globalDiscount };
      }
      case GET_GLOBAL_DISCOUNT_SUCCESS: {
        const globalDiscount = Object.assign({}, state.globalDiscount);
        globalDiscount.errorMessage = '';
        globalDiscount.discount = parseFloat(action.response.discount) || 0;
        return { ...state, globalDiscount };
      }
      case GET_GLOBAL_DISCOUNT_FAILURE: {
        const globalDiscount = Object.assign({}, state.globalDiscount);
        globalDiscount.errorMessage = action.errorMessage;

        return { ...state, globalDiscount };
      }
      case SET_GLOBAL_DISCOUNT_REQUEST: {
        const globalDiscount = Object.assign({}, state.globalDiscount);
        globalDiscount.errorMessage = '';
        globalDiscount.isFetching = true;

        return { ...state, globalDiscount };
      }
      case SET_GLOBAL_DISCOUNT_SUCCESS: {
        const globalDiscount = Object.assign({}, state.globalDiscount);
        globalDiscount.errorMessage = '';
        globalDiscount.discount = action.params.globalDiscount;
        return { ...state, globalDiscount };
      }
      case SET_GLOBAL_DISCOUNT_FAILURE: {
        const globalDiscount = Object.assign({}, state.globalDiscount);
        globalDiscount.errorMessage = action.errorMessage;

        return { ...state, globalDiscount };
      }
      case CLEAR_ALL_ERROR_MESSAGES: {
        const newState = Object.assign({}, state);
        Object.keys(state).forEach((key) => {
          if (newState[key] && newState[key].errorMessage) {
            newState[key].errorMessage = '';
          }
        });
        return newState;
      }
      default: {
        return state;
      }
    }
  }
  return state;
};

const initState = () => ({
  salonVatRate: 0,
  stylistIDInCalendarOrder: [],
  currentTable: '',
  transactionLog: {
    isFetching: false,
    errorMessage: '',
  },
  bookingLog: {
    isFetching: false,
    errorMessage: '',
  },
  deletedBookingLog: {
    isFetching: false,
    errorMessage: '',
  },
  appointmentsReport: {
    isFetching: false,
    errorMessage: '',
  },
  salonHoursReport: {
    isFetching: false,
    errorMessage: '',
  },
  salesReport: {
    isFetching: false,
    errorMessage: '',
  },
  salesDiscountsReport: {
    isFetching: false,
    errorMessage: '',
  },
  commissionReport: {
    isFetching: false,
    errorMessage: '',
  },
  allCommissionReport: {
    isFetching: false,
    errorMessage: '',
  },
  rebookingReport: {
    isFetching: false,
    errorMessage: '',
  },
  dailyRebookingReport: {
    isFetching: false,
    errorMessage: '',
  },
  forecastRevenue: {
    isFetching: false,
    errorMessage: '',
  },
  actualSalesData: {
    isFetching: false,
    errorMessage: '',
  },
  uniqueClientsReport: {
    isFetching: false,
    errorMessage: '',
  },
  uniqueVisitsReport: {
    isFetching: false,
    errorMessage: '',
  },
  visitFrequencyReport: {
    isFetching: false,
    errorMessage: '',
  },
  stylistPerformedCategoriesReport: {
    isFetching: false,
    errorMessage: '',
  },
  lastDatesSelected: {
    fromDate: moment().weekday(0),
    toDate: moment().weekday(6),
    lastCalenderClicked: '',
  },
  lastMonthlyDatesSelected: null,
  globalDiscount: {
    discount: 0,
    isFetching: false,
    errorMessage: '',
  },
  newClientsReport: {
    isFetching: false,
    errorMessage: '',
  },
  monthlyRevenueReport: {
    isFetching: false,
    errorMessage: '',
  },
  isFetching: false,
});

const sortArrayBaccordingToArrayA = (a, b) => {
  const IDs = a.map((e) => e.id);
  const newB = [];
  if (b) {
    for (let i = 0; i < IDs.length; i += 1) {
      const elementArray = b.filter((s) => s.id === IDs[i]);
      if (elementArray.length > 0) {
        const e = elementArray[0];
        newB.push(e);
      }
    }
    const newBId = newB.map((e) => e.id);
    for (let i = 0; i < b.length; i += 1) {
      if (newBId.indexOf(b[i].id) < 0) {
        newB.push(b[i]);
      }
    }
  }
  return newB;
};

const checkIsFetching = (key, state) => {
  const allReports = [
    'newClientsReport',
    'appointmentsReport',
    'salonHoursReport',
    'salesReport',
    'salesDiscountsReport',
    'commissionReport',
    'rebookingReport',
    'dailyRebookingReport',
    'forecastRevenue',
    'actualSalesData',
    'uniqueClientsReport',
    'uniqueVisitsReport',
    'visitFrequencyReport',
    'stylistPerformedCategoriesReport',
  ];
  for (let i = 0; i < allReports.length; i += 1) {
    if (allReports[i] !== key) {
      if (state[allReports[i]].isFetching) {
        return true;
      }
    }
  }
  return false;
};

const reportsReducer = (state = initState(), action) => {
  const actionResponse = action?.response;

  if (!action?.type) return state;

  switch (action.type) {
    case TRANSACTION_LOG_CSV_REQUEST:
    case BOOKING_LOG_CSV_REQUEST:
    case DELETED_BOOKING_LOG_CSV_REQUEST: {
      const log = Object.assign({}, state[action.params.key]);
      log.isFetching = true;
      log.errorMessage = '';

      const newState = { ...state };
      newState[action.params.key] = log;
      return newState;
    }
    case TRANSACTION_LOG_CSV_SUCCESS:
    case BOOKING_LOG_CSV_SUCCESS:
    case DELETED_BOOKING_LOG_CSV_SUCCESS: {
      const log = Object.assign({}, state[action.params.key]);
      log.isFetching = false;
      log.errorMessage = '';
      const fileName = `${action.params.key}-${moment(action.params.startDate).format('YYYY-MM-DD')}-${moment(
        action.params.endDate,
      ).format('YYYY-MM-DD')}.csv`;

      fileDownload(actionResponse, fileName);

      const newState = { ...state };
      newState[action.params.key] = log;
      return newState;
    }
    case TRANSACTION_LOG_CSV_FAILURE:
    case BOOKING_LOG_CSV_FAILURE:
    case DELETED_BOOKING_LOG_CSV_FAILURE: {
      const log = Object.assign({}, state[action.params.key]);
      log.isFetching = false;
      log.errorMessage = action.errorMessage;

      const newState = { ...state };
      newState[action.params.key] = log;
      return newState;
    }
    case GET_MONTHLY_REVENUE_REQUEST:
    case APPOINTMENTS_REPORT_REQUEST:
    case REBOOKING_REPORT_REQUEST:
    case DAILY_REBOOKING_REPORT_REQUEST:
    case SALON_HOURS_REPORT_REQUEST:
    case SALES_REPORT_REQUEST:
    case FORECAST_REVENUE_REQUEST:
    case COMMISSION_REPORT_REQUEST:
    case GET_UNIQUE_CLIENTS_REQUEST:
    case GET_VISIT_FREQUENCY_REQUEST:
    case GET_UNIQUE_VISITS_REQUEST:
    case GET_STYLISTS_REQUESTS_REQUEST:
    case SALES_DISCOUNTS_REPORT_REQUEST:
    case NEW_CLIENTS_REQUEST:
    case GET_PRODUCT_SALES_REQUEST:
    case GET_PRODUCT_SALES_BY_STYLIST_REQUEST:
    case STYLIST_PERFORMED_CATEGORIES_REQUEST:
    case ALL_COMMISSION_REPORT_REQUEST:
    case ACTUAL_SALES_DATA_REQUEST: {
      const report = Object.assign({}, state[action.params.key]);
      report.isFetching = true;
      report.errorMessage = '';
      report.lastRequestResponse = undefined;

      const newState = { ...state };
      newState[action.params.key] = report;
      newState.isFetching = true;
      return newState;
    }
    case NEW_CLIENTS_SUCCESS: {
      const report = Object.assign({}, state.newClientsReport);
      report.isFetching = false;
      report.errorMessage = '';
      report.lastRequestResponse = actionResponse ?? {};
      const unsortedStylists = actionResponse && actionResponse.stylists;
      const { stylistIDInCalendarOrder } = state;
      let sortedStylists;
      if (stylistIDInCalendarOrder.length > 0) {
        sortedStylists = sortArrayBaccordingToArrayA(stylistIDInCalendarOrder, unsortedStylists);
      }
      report.lastRequestResponse.stylists = sortedStylists;
      report.start_date = moment(action.params.startDate).toISOString();
      report.end_date = moment(action.params.endDate).toISOString();
      const newState = { ...state };
      newState.isFetching = checkIsFetching(action.params.key, state);
      newState.newClientsReport = report;
      return newState;
    }
    case STYLIST_PERFORMED_CATEGORIES_SUCCESS: {
      const stylistIDs = actionResponse.map((s) => s.id);
      const { stylistIDInCalendarOrder } = state;
      let NewstylistIDInCalendarOrder;

      if (stylistIDInCalendarOrder && stylistIDInCalendarOrder.length > 0) {
        NewstylistIDInCalendarOrder = stylistIDInCalendarOrder.slice();
        for (let i = 0; i < stylistIDs.length; i += 1) {
          const missed = stylistIDInCalendarOrder.filter((s) => s.id === stylistIDs[i]);
          const missedID = stylistIDs[i];

          if (missed.length === 0) {
            const stylistDeleted = actionResponse.filter((e) => e.id === missedID)[0];
            const missingData = Object.assign({}, stylistDeleted);
            missingData.id = stylistDeleted.id;
            missingData.user_name = stylistDeleted.name;

            NewstylistIDInCalendarOrder.push(missingData);
          }
        }
      }
      const report = Object.assign({}, state[action.params.key]);
      report.isFetching = false;
      report.errorMessage = '';
      report.lastRequestResponse = actionResponse;

      report.start_date = moment(action.params.startDate).toISOString();
      report.end_date = moment(action.params.endDate).toISOString();
      const newState = { ...state, stylistIDInCalendarOrder: NewstylistIDInCalendarOrder };
      newState[action.params.key] = report;
      newState.isFetching = checkIsFetching(action.params.key, state);
      return newState;
    }
    case GET_MONTHLY_REVENUE_SUCCESS: {
      const report = Object.assign({}, state[action.params.key]);
      report.isFetching = false;
      const updatedRespons = Object.assign({}, actionResponse);
      for (let i = 0; i < Object.keys(updatedRespons).length; i++) {
        const stylistGroup = Object.entries(updatedRespons)[i][1].stylist_group;
        const monthKey = Object.entries(updatedRespons)[i][0];
        const employedForThisMonth = {
          name: '',
          revenue_from_products: 0,
          revenue_from_no_shows: 0,
          revenue_from_services: 0,
          total_revenue: 0,
        };
        const selfEmployedForThisMonth = {
          name: '',
          revenue_from_products: 0,
          revenue_from_no_shows: 0,
          revenue_from_services: 0,
          total_revenue: 0,
        };

        for (let j = 0; j < stylistGroup.length; j++) {
          if (stylistGroup[j].is_self_employed === false) {
            employedForThisMonth.name = 'employed';
            employedForThisMonth.total_revenue += stylistGroup[j].total_revenue;
            employedForThisMonth.revenue_from_no_shows += stylistGroup[j].revenue_from_no_shows;
            employedForThisMonth.revenue_from_products += stylistGroup[j].revenue_from_products;
            employedForThisMonth.revenue_from_services += stylistGroup[j].revenue_from_services;
          } else {
            selfEmployedForThisMonth.name = 'selfemployed';
            selfEmployedForThisMonth.total_revenue += stylistGroup[j].total_revenue;
            selfEmployedForThisMonth.revenue_from_no_shows += stylistGroup[j].revenue_from_no_shows;
            selfEmployedForThisMonth.revenue_from_products += stylistGroup[j].revenue_from_products;
            selfEmployedForThisMonth.revenue_from_services += stylistGroup[j].revenue_from_services;
          }

          updatedRespons[monthKey].stylist_group.employed = employedForThisMonth;
          updatedRespons[monthKey].stylist_group.selfemployed = selfEmployedForThisMonth;
        }
      }
      report.lastRequestResponse = updatedRespons;
      report.errorMessage = '';
      if (Object.keys(actionResponse).length === 0) {
        report.errorMessage = 'No data available';
      }
      report.start_date = moment(action.params.startDate).toISOString();
      report.end_date = moment(action.params.endDate).toISOString();
      const newState = { ...state };
      newState.isFetching = checkIsFetching(action.params.key, state);
      newState[action.params.key] = report;
      return newState;
    }
    case APPOINTMENTS_REPORT_SUCCESS:
    case REBOOKING_REPORT_SUCCESS:
    case DAILY_REBOOKING_REPORT_SUCCESS:
    case SALON_HOURS_REPORT_SUCCESS:
    case FORECAST_REVENUE_SUCCESS:
    case GET_UNIQUE_CLIENTS_SUCCESS:
    case GET_UNIQUE_VISITS_SUCCESS:
    case GET_VISIT_FREQUENCY_SUCCESS:
    case GET_STYLISTS_REQUESTS_SUCCESS:
    case SALES_DISCOUNTS_REPORT_SUCCESS:
    case GET_PRODUCT_SALES_SUCCESS:
    case GET_PRODUCT_SALES_BY_STYLIST_SUCCESS:
    case ALL_COMMISSION_REPORT_SUCCESS:
    case ACTUAL_SALES_DATA_SUCCESS: {
      const report = Object.assign({}, state[action.params.key]);
      report.isFetching = false;
      report.lastRequestResponse = actionResponse;
      report.errorMessage = '';
      report.start_date = moment(action.params.startDate).toISOString();
      report.end_date = moment(action.params.endDate).toISOString();
      const newState = { ...state };
      newState.isFetching = checkIsFetching(action.params.key, state);
      newState[action.params.key] = report;
      return newState;
    }
    case CREATE_COMMISSION_RATE_SUCCESS: {
      const { stylist_group } = state.salesReport.lastRequestResponse;
      const changedCommissionStylist = stylist_group.filter((item) => item.id === action.params.data.stylist)[0].name;

      const { allCommissionReport } = state;
      const copyOfAllCommissionReport = Object.assign({}, allCommissionReport);
      let clist;
      if (copyOfAllCommissionReport.lastRequestResponse[changedCommissionStylist]) {
        clist = copyOfAllCommissionReport.lastRequestResponse[changedCommissionStylist].slice();
      } else {
        clist = [];
      }
      clist.push(actionResponse);
      copyOfAllCommissionReport.lastRequestResponse[changedCommissionStylist] = clist;
      return { ...state, allCommissionReport: copyOfAllCommissionReport };
    }
    case CHANGE_COMMISSION_RATE_SUCCESS: {
      const { stylist_group } = state.salesReport.lastRequestResponse;
      const changedCommissionStylist = stylist_group.filter((item) => item.id === action.params.data.stylist)[0].name;

      const { allCommissionReport } = state;
      const copyOfAllCommissionReport = Object.assign({}, allCommissionReport);
      const commissionsForStylist = copyOfAllCommissionReport.lastRequestResponse[changedCommissionStylist];
      let changedItem;
      if (action.params.data.id !== -1) {
        [changedItem] = commissionsForStylist.filter((c) => c.id.toString() === action.params.data.id.toString());
        changedItem.percentage = action.params.data.percentage;
      } else {
        const clist = copyOfAllCommissionReport.lastRequestResponse[changedCommissionStylist].slice();
        clist.push(actionResponse);
        copyOfAllCommissionReport.lastRequestResponse[changedCommissionStylist] = clist;
      }
      return { ...state, allCommissionReport: copyOfAllCommissionReport };
    }
    case SALES_REPORT_SUCCESS: {
      const key = 'salesReport';
      const report = Object.assign({}, state[key]);
      report.isFetching = false;
      report.errorMessage = '';
      report.lastRequestResponse = actionResponse;
      const unsortedStylistGroup = actionResponse.stylist_group;
      const activeStylists = action.params.stylistList.filter((s) => s.status === 'active' && s.status !== 'deleted');
      report.lastRequestResponse.stylist_group = sortArrayBaccordingToArrayA(activeStylists, unsortedStylistGroup);
      report.start_date = moment(action.params.startDate).toISOString();
      report.end_date = moment(action.params.endDate).toISOString();
      const newState = { ...state };
      newState[key] = report;
      newState.isFetching = checkIsFetching(key, state);
      return newState;
    }
    case GET_MONTHLY_REVENUE_FAILURE:
    case NEW_CLIENTS_FAILURE:
    case APPOINTMENTS_REPORT_FAILURE:
    case REBOOKING_REPORT_FAILURE:
    case DAILY_REBOOKING_REPORT_FAILURE:
    case SALON_HOURS_REPORT_FAILURE:
    case SALES_REPORT_FAILURE:
    case FORECAST_REVENUE_FAILURE:
    case COMMISSION_REPORT_FAILURE:
    case GET_UNIQUE_CLIENTS_FAILURE:
    case GET_UNIQUE_VISITS_FAILURE:
    case GET_VISIT_FREQUENCY_FAILURE:
    case GET_STYLISTS_REQUESTS_FAILURE:
    case SALES_DISCOUNTS_REPORT_FAILURE:
    case GET_PRODUCT_SALES_FAILURE:
    case GET_PRODUCT_SALES_BY_STYLIST_FAILURE:
    case STYLIST_PERFORMED_CATEGORIES_FAILURE:
    case ALL_COMMISSION_REPORT_FAILURE:
    case ACTUAL_SALES_DATA_FAILURE: {
      const report = Object.assign({}, state[action.params.key]);
      report.isFetching = false;
      report.errorMessage = action.errorMessage || 'No data available';
      report.lastRequestResponse = undefined;

      const newState = { ...state };
      newState[action.params.key] = report;
      newState.isFetching = checkIsFetching(action.params.key, state);
      return newState;
    }
    case COMMISSION_REPORT_SUCCESS: {
      const commissionReport = Object.assign({}, state.commissionReport);
      commissionReport.isFetching = false;
      commissionReport.errorMessage = '';
      commissionReport.lastRequestResponse = {
        stylistId: action.params.stylistId,
        response: actionResponse,
      };
      const isFetching = checkIsFetching(action.params.key, state);

      return { ...state, commissionReport, isFetching };
    }
    case SET_DATE_PICKER_DATE: {
      const salonVatRate = state?.salonVatRate;

      const { fromDate: stateBgn, toDate: stateEnd } = state?.lastDatesSelected ?? {};
      const { fromDate: actionBgn, toDate: actionEnd } = action ?? {};

      const fromDate = actionBgn ? actionBgn : stateBgn;
      const toDate = actionEnd ? actionEnd : stateEnd;

      const lastDatesSelected = {
        fromDate,
        toDate: isTimeBefore(toDate, fromDate) ? moment(fromDate).add(6, 'day').endOf('day') : toDate,
        lastCalenderClicked: actionEnd ? 'toDate' : 'fromDate',
      };

      const isEndDifferent = moment(actionEnd).diff(moment(stateEnd), 'days') > 0;
      const isBgnDifferent = moment(actionBgn).diff(moment(stateBgn), 'day') > 0;

      return actionEnd && (isEndDifferent || isBgnDifferent)
        ? { ...initState(), lastDatesSelected, salonVatRate }
        : { ...state, lastDatesSelected, salonVatRate };
    }

    case SET_MONTHLY_DATE_PICKER_DATE: {
      const { fromDate, toDate, isFromDate } = action;
      let endDate;
      if (!toDate) {
        let year = moment().get('year');
        let month = moment().get('month') === 0 ? 12 : moment().get('month');
        if (month < 10) {
          month = `0${month}`;
        }
        if (month === 12) {
          year -= 1;
        }
        endDate = moment(`${year}${month}01`).endOf('month');
      }

      const lastMonthlyDatesSelected = {
        fromDate,
        toDate: toDate || endDate,
        isFromDate,
      };
      // when date changes we start to fetch monthly revenue
      return { ...state, lastMonthlyDatesSelected, isFetching: !isFromDate };
    }
    case SET_SALON_VAT_RATE: {
      let salonVatRate = parseFloat(action.vat);
      if (salonVatRate > 100) {
        salonVatRate = 100;
      }
      if (salonVatRate < 0) {
        salonVatRate = -salonVatRate;
      }
      return { ...state, salonVatRate };
    }
    case SET_STYLIST_ID_ORDER: {
      return { ...state, stylistIDInCalendarOrder: action.IDs };
    }
    case SET_CURRENT_TABLE: {
      return { ...state, currentTable: action.table };
    }
    default: {
      // if we can't handle it here, we'll try to handle it with the other reducer
      // that handles all the logic without fetching reports data
      return reportsEtcReducer(state, action);
    }
  }
};

export default reportsReducer;
